import { useSnackbar } from 'notistack';
import { memo, useCallback, useEffect } from 'react';
import { NotificationManager } from './NotificationManager';
import { Notification } from './Notification';

export const NotificationDisplayer = memo(() => {
  const { enqueueSnackbar } = useSnackbar();

  const cb = useCallback(
    (event: CustomEvent<Notification[]>) => {
      const { detail: notifications } = event;
      for (const notification of notifications) {
        enqueueSnackbar(notification.getMessage(), {
          variant: notification.getType(),
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          style: { whiteSpace: 'pre' },
          preventDuplicate: true,
        });
      }
    },
    [enqueueSnackbar]
  );

  useEffect(() => {
    NotificationManager.subscribe(cb);
    return () => {
      NotificationManager.unsubscribe(cb);
    };
  }, [enqueueSnackbar, cb]);

  return <></>;
});
